import React from 'react';
import * as Tabs from '@radix-ui/react-tabs';

export default function TabsList({ className = '', sitePlans }) {
  return (
    <Tabs.List className={className || 'siteplan__tabs'}>
      {sitePlans?.map((siteplan, index) => (
        <Tabs.Trigger
          className="siteplan__button"
          key={`siteplan-button-${index}`}
          value={siteplan.name}
        >
          {siteplan.name}
        </Tabs.Trigger>
      ))}
    </Tabs.List>
  );
}
